import { useTranslation } from "react-i18next";
import { ao3Keywords } from "@/mocks/ao3Home";
import Ao3Reveal from "./Ao3Reveal";

export default function Ao3Keywords() {
  const { t } = useTranslation();

  return (
    <section id="ao3-keywords" className="w-full bg-background-100 border-y border-background-200/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6 text-center">
        <Ao3Reveal>
          <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 dark:text-primary-400">{t("keywords.badge")}</span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">{t("keywords.title")}</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{t("keywords.subtitle")}</p>
        </Ao3Reveal>

        <Ao3Reveal className="mt-8" delay={120}>
          <ul className="flex flex-wrap items-center justify-center gap-2.5 md:gap-3">
            {ao3Keywords.map((keyword) => (
              <li key={keyword}>
                <span className="inline-flex items-center gap-2 rounded-full border border-background-300/70 bg-background-50 px-4 py-2 text-xs font-medium text-foreground-800 md:text-sm">
                  <i className="ri-search-line text-sm leading-none text-primary-600 dark:text-primary-400" />
                  {keyword}
                </span>
              </li>
            ))}
          </ul>
        </Ao3Reveal>
      </div>
    </section>
  );
}